import { wishlistsPagePath } from '../whislists/WishlistsPage.shared';

export const wishlistSharedPath = `${wishlistsPagePath}/shared/:id`;

export const getWishlistSharedUrl = (id: string) => wishlistSharedPath.replace(':id', id);